import { Injectable } from '@angular/core';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EnvService } from './env.service';
import { catchError, map } from 'rxjs/operators';
import { CallBackTransformService } from './call-back-transform.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  helperIndex = new BehaviorSubject<string>(undefined);
  private advancesearchSubject = new BehaviorSubject<any>({});
  currentHelper = undefined;
  private pageNoSubject = new BehaviorSubject<number>(1);
  private pageSizeSubject = new BehaviorSubject<number>(20);
  currentPageNo = this.pageNoSubject.asObservable();
  currentPageSize = this.pageSizeSubject.asObservable();
  constructor(
    private http: HttpClient,
    private envService: EnvService,
    private CallBackService: CallBackTransformService
  ) {}

  setPageNo(pageNo: number): void {
    this.pageNoSubject.next(pageNo);
  }

  setPageSize(pageSize: number): void {
    this.pageSizeSubject.next(pageSize);
  }
  /**
   * Get Dashboard Needs Metrics details
   * @param number helperIndex
   * @param number pageNumber
   * @param number pageSize
   */
  getDashboardNeedsMetrics(searchObject): Observable<any> {
    const url = this.envService.apiUrl + `need-metrics`;
    return this.http.post<any>(url, searchObject).pipe(
      map((output) => {
        return this.CallBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.CallBackService.transformOutput(err));
      })
    );
  }

  /**
   * To fetch dashboard strengths metrics
   * @param object searchObject
   */
  getDashboardStrengthsMetrics(searchObject): Observable<any> {
    const url = this.envService.apiUrl + `strength-metrics`;
    return this.http.post<any>(url, searchObject).pipe(
      map((output) => {
        return this.CallBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.CallBackService.transformOutput(err));
      })
    );
  }

  /**
   * get Dashboard Notifications Summary details
   * @param Object searchObject
   */
  getDashboardNotificationsSummary(searchObject,isDashboardView?:boolean): Observable<any> {
    let headers = new HttpHeaders();
    if(isDashboardView){
       headers = new HttpHeaders().set('ignoreProgressBar', "");
    }
    const options = { headers: headers };
    const url = this.envService.apiUrl + 'notification-log';
    return this.http.post<any>(url, searchObject,options).pipe(
      map((output) => {
        return this.CallBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.CallBackService.transformOutput(err));
      })
    );
  }

  /**
   * get past Dashboard Notifications Summary details
   * @param Object searchObject
   */
  getPastNotificationsSummary(searchObject): Observable<any> {
    const url = this.envService.apiUrl + 'past-notification-log';
    return this.http.post<any>(url, searchObject).pipe(
      map((output) => {
        return this.CallBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.CallBackService.transformOutput(err));
      })
    );
  }

  /**
   * Get People Helping Count
   */
  getPeopleHelpingCount(helperIndex?: any): Observable<any> {
    const url =
      this.envService.apiUrl +
      'personhelping-count' +
      (!helperIndex || helperIndex === '' ? '' : `/${helperIndex}`);
    return this.http.get<any>(url).pipe(
      map((output) => {
        return this.CallBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.CallBackService.transformOutput(err));
      })
    );
  }

  /**
   * set Helperindex
   * @param number helperIndex
   */
  setHelperIndex(helper: any): void {
    this.currentHelper = helper;
    if (helper && helper.helperIndex) {
      this.helperIndex.next(helper.helperIndex);
    } else {
      this.helperIndex.next(undefined);
    }
  }

  /**
   * get helperindex
   */
  getHelperIndex(): Observable<string> {
    return this.helperIndex.asObservable();
  }

  /**
   * Get Current Helper Index
   */
  getCurrentHelperIndex() {
    if (this.currentHelper && this.currentHelper.helperIndex) {
      return this.currentHelper.helperIndex;
    } else {
      return undefined;
    }
  }

  /**
   * Get Current Helper Name
   */
  getCurrentHelper() {
    return this.currentHelper;
  }

  /**
   * To fetch upper pane search list
   * @param string searchText
   * @param number pageNumber
   * @param number pageSize
   */
  getUpperPaneSearchList(searchObj): Observable<any> {
    const url = this.envService.apiUrl + `search`;
    return this.http.post<any>(url, searchObj).pipe(
      map((output) => {
        return this.CallBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.CallBackService.transformOutput(err));
      })
    );
  }
  advancedSearchSubmit(searchInfo): Observable<any> {
    const url = this.envService.apiUrl + 'advance-search-agency';
    return this.http.post<any>(url, searchInfo).pipe(
      map((output) => {
        return this.CallBackService.transformOutput(output);
      }),
      catchError((err) => {
        return throwError(this.CallBackService.transformOutput(err));
      })
    );
  }
  setAdvanceSearchPayload(value: any) {
    this.advancesearchSubject.next(value);
  }
  getAdvanceSearchPayload() {
    return this.advancesearchSubject.asObservable();
  }
  removeNeedsAndStrengthFromLocalStorage() {
    localStorage.removeItem('needssMetrics');
    localStorage.removeItem('strengthsMetrics');
  }
}
